module.exports = __webpack_public_path__ + "img/1528770568.5df9acce.jpg";